import confirmExistingStudent from 'html/layouts/confirm-existing-student.html';
import App from 'app/app.js';
import 'app/directive/LtInstantPromoPopupCtrl.js';

function LtConfirmExistingStudentDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      goHome: '&',
      openStudentTab: '='
    },
    template: confirmExistingStudent,
    controller: 'LtConfirmExistingStudentCtrl',
    controllerAs: 'confirmExistingStudent'
  };
}

App.directive('ltConfirmExistingStudent', [LtConfirmExistingStudentDirective]);
